
import pageHearder from "./common/Hearder.vue";
import LoginMsg from "./common/Loginmsg.vue";
import Alert from 'vux/src/components/alert/index.vue'

import { Indicator } from 'mint-ui';




export default {
name: "OprationData",
props: [],
components: {
pageHearder,
LoginMsg,
Alert
},

data() {
return {
selected: "1",
showService: false,
page: 1,
wordList: [],
tabList: [
{id: "1", name: "热点", type: "1", asort: "20"},
{id: "30", name: "降权申诉", type: "1", asort: "0"},
{id: "22", name: "爆款打造", type: "1", asort: "18"},
{id: "3", name: "直通车技巧", type: "1", asort: "0"},
{id: "24", name: "运营推广", type: "1", asort: "0"},
{id: "34", name: "标题优化", type: "1", asort: "0"}
],
cat_name: "热点"
};
},

methods: {
goPage: function(url) {
this.$router.push(url);
},

handleShowService: function() {
this.showService = true;
},

goWordDetail: function(item) {
window.open(item.file_url, '_self')

},












handleChangeTab: function(tabId) {
Indicator.open();
let url = `https://mjxqapi.diantoushi.com/api/index/dtscatlist?cat_id=${tabId}&page=1&page_size=30`;

axios.get(url).then(res => {
let data = JSON.parse(res.data.data);
this.wordList = data.list;
this.cat_name = data.cat_name;
Indicator.close();
});
}
},

mounted() {

this.handleChangeTab("1");
},

watch: {
selected: function() {
this.handleChangeTab(this.selected);
}
}
};
